import { FormMessage } from 'clinical-forms-experience-client';
import { get } from 'http';

interface Props {
    message: FormMessage
};

const FormMessageView = ({ message }: Props) => {
    const getClassName = (priority: number) => {
        switch (priority) {
            case 3:
                return 'bg-danger text-white';
            case 2:
                return 'bg-warning text-white';
            case 1:
                return 'bg-success text-white';
            case 0:
                return 'bg-info text-white';
            default:
                return 'bg-info text-white';
        }
    }

    return (
        <div className={"rounded mt-2 p-2 d-flex " + getClassName(message.priority)}>
            <div className='flex-0'><span className="material-symbols-outlined">info</span></div>
            <div className='ms-2 flex'>{message.message}</div>
        </div>
    );
};

export default FormMessageView;